import { DOCUMENT, Injectable, type Renderer2, RendererFactory2, RendererStyleFlags2, inject } from '@angular/core';

const themingPrefix = 'theming';
export function generateThemingVariable(variablePath: string[]) {
    return `--${themingPrefix}-${variablePath.join('-')}`;
}

@Injectable({
    providedIn: 'root'
})
export class SharedUiThemingCssVariablesService {
    private document = inject<Document>(DOCUMENT);

    private renderer: Renderer2;
    private ROOT: HTMLElement;

    constructor() {
        const rendererFactory = inject(RendererFactory2);

        this.renderer = rendererFactory.createRenderer(null, null);
        this.ROOT = this.document.documentElement;
    }

    setThemingCssVariable(themingCategory: string, cssVariableName: string, value: string) {
        this.renderer.setStyle(this.ROOT, generateThemingVariable([themingCategory, cssVariableName]), value, RendererStyleFlags2.DashCase);
    }

    setPrecomputedThemingCssVariable(precomputedVariableName: string, value: string) {
        this.renderer.setStyle(this.ROOT, precomputedVariableName, value, RendererStyleFlags2.DashCase);
    }
}
